import { Box, Pressable, usePropsResolution } from 'native-base';
import React from 'react';
import { StarFilled } from '../Icon';
import type { IStarRatingProps } from './StarRating.types';

const StarRating: React.FunctionComponent<IStarRatingProps> = ({
  disabled,
  onChange,
  stars = 5,
  testID = 'StarRating',
  value,
}) => {
  const { _container, _iconActive, _icon } = usePropsResolution(
    'StarRating',
    {}
  );
  return (
    <Box {..._container} testID={testID}>
      {[...Array(stars)].map((_, index) => {
        const starValue = index + 1;

        return (
          <Pressable
            disabled={disabled}
            key={index}
            testID={`${testID}--Pressable-${starValue}`}
            onPress={() => {
              onChange(starValue);
            }}
          >
            {({ isPressed }) => (
              <Box>
                <StarFilled
                  {..._icon}
                  {...((isPressed || (value ? starValue <= value : false)) &&
                    _iconActive)}
                />
              </Box>
            )}
          </Pressable>
        );
      })}
    </Box>
  );
};

export default StarRating;
